import getExtensibilityState from '../store/getExtensibilityState';
import InvokeAppAddinCommandStatusCode from '../store/schema/enums/InvokeAppAddinCommandStatusCode';
import { resolvePendingUILess } from '../store/pendingUILess';
import { action } from 'satcheljs/lib/legacy';

export default action('terminateUilessAddinCommand')(function terminateUilessAddinCommand(
    controlId: string,
    hostItemIndex: string,
    status: InvokeAppAddinCommandStatusCode,
    context?: { allowEvent?: boolean }
) {
    resolvePendingUILess(controlId, {
        status,
        allowEvent: context && context.allowEvent,
    });

    const runningUILessAddinCommands = getExtensibilityState().runningUILessAddinCommands;
    if (runningUILessAddinCommands.has(hostItemIndex)) {
        runningUILessAddinCommands.get(hostItemIndex).delete(controlId);
        if (runningUILessAddinCommands.get(hostItemIndex).size === 0) {
            runningUILessAddinCommands.delete(hostItemIndex);
        }
    }
});
